import { render, staticRenderFns } from "./ProductSpecs.vue?vue&type=template&id=1bf8225a&"
import script from "./ProductSpecs.vue?vue&type=script&lang=js&"
export * from "./ProductSpecs.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecs.vue?vue&type=style&index=0&id=1bf8225a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports